import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Zap, Info, Activity, AlertTriangle, } from 'lucide-react';

const EnginePerformanceChart2 = ({ selectedEngine, mainEngineData }) => {
  const enginePowerCurveData = mainEngineData?.enginePowerCurveData || {};
  const hasData = enginePowerCurveData.engineCurve?.length > 0;

  console.log("EnginePowerCurveData:", enginePowerCurveData);
  
  const categories = hasData ? (enginePowerCurveData.rpmPercentage || []) : [];
  
  const seriesData = hasData ? [
    {
      name: 'Engine Curve',
      data: enginePowerCurveData.engineCurve || [],
      color: '#7d3c98'
    }
  ] : [];

  const options = {
    chart: {
      type: 'line',
      height: 450,
      backgroundColor: 'transparent',
      style: {
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
      }
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    xAxis: {
      categories: categories,
      title: {
        text: '% of MCR RPM',
        style: {
          color: '#64748B',
          fontWeight: '600',
          fontSize: '13px'
        }
      },
      gridLineWidth: 1,
      gridLineColor: '#F1F5F9',
      lineColor: '#E2E8F0',
      lineWidth: 1,
      labels: {
        style: {
          color: '#64748B',
          fontSize: '12px'
        },
        rotation: -45
      }
    },
    yAxis: {
      title: {
        text: '% of MCR Power',
        style: {
          color: '#64748B',
          fontWeight: '600',
          fontSize: '13px'
        }
      },
      gridLineColor: '#F1F5F9',
      lineColor: '#E2E8F0',
      lineWidth: 1,
      labels: {
        style: {
          color: '#64748B',
          fontSize: '12px'
        },
        format: '{value}%'
      },
      max: 130
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      line: {
        marker: {
          radius: 5,
          symbol: 'circle',
          lineWidth: 2,
          lineColor: '#FFFFFF',
          fillOpacity: 1
        },
        lineWidth: 3,
        states: {
          hover: {
            lineWidth: 4,
            halo: {
              size: 8,
              opacity: 0.1
            }
          }
        }
      },
      series: {
        label: {
          connectorAllowed: false
        },
        pointStart: 40,
        pointInterval: 5
      }
    },
    tooltip: {
      shared: true,
      backgroundColor: '#FFFFFF',
      borderColor: '#E2E8F0',
      borderRadius: 8,
      borderWidth: 1,
      shadow: true,
      useHTML: true,
      headerFormat: '<div class="text-sm font-semibold text-slate-800 mb-1">{point.key}% RPM</div>',
      pointFormat: '<div class="flex items-center py-1"><span class="inline-block w-3 h-3 rounded-full mr-2" style="background-color:{series.color}"></span><span class="text-slate-600 font-medium">{series.name}:</span><span class="ml-auto font-semibold text-slate-800">{point.y}%</span></div>',
      style: {
        fontSize: '13px'
      }
    },
    series: seriesData,
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom'
          }
        }
      }]
    }
  };

  return (
    <div className="bg-white rounded-xl border border-slate-100 shadow-sm overflow-hidden transition-all hover:shadow-md">
      {/* Header */}
      <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between bg-gradient-to-r from-slate-50 to-white">
        <div className="flex items-center gap-3">
          <div className="p-1.5 bg-[#e1f5fb] text-[#27ade3] rounded-md">
            <Zap className="w-5 h-5" strokeWidth="2" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-slate-800 tracking-tight">
              Engine Performance - {selectedEngine?.toUpperCase()}
            </h2>
            <p className="text-xs text-slate-500 mt-0.5 flex items-center gap-1">
              <Info className="w-3 h-3" />
              Power vs RPM curves
            </p>
          </div>
        </div>
      </div>
      
      {/* Chart container */}
      <div className="p-5 pt-3">
        {hasData ? (
          <>
            <div className="flex flex-wrap justify-between items-center mb-4 gap-4">
              <div className="flex flex-wrap gap-4">
                {seriesData.map((series) => (
                  <div key={series.name} className="flex items-center">
                    <span 
                      className="inline-block w-3 h-3 rounded-full mr-2 shadow-sm" 
                      style={{ 
                        backgroundColor: series.color,
                        border: series.dashStyle ? '2px solid ' + series.color : 'none'
                      }}
                    ></span>
                    <span className="text-sm font-medium text-slate-700">{series.name}</span>
                  </div>
                ))}
              </div>
            </div>
            
            <HighchartsReact
              highcharts={Highcharts}
              options={options}
              constructorType={'chart'}
            />
          </>
        ) : (
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <div className="p-4 bg-slate-50 rounded-full mb-4">
              <Info className="w-8 h-8 text-slate-400" />
            </div>
            <h3 className="text-lg font-medium text-slate-700 mb-1">No Engine Curve Data Available</h3>
          </div>
        )}
      </div>
    </div>
  );
};



// const EnginePerformanceChart2 = ({ selectedEngine, mainEngineData }) => {
//   const enginePowerCurveData = mainEngineData?.enginePowerCurveData || {};
  
//   // Get actual points
//   const actualPoints = enginePowerCurveData.actualPoints || [];
//   const hasData = actualPoints.length > 0;
  
//   console.log("Engine Performance Data:", {
//     points: actualPoints,
//     count: actualPoints.length,
//     stats: enginePowerCurveData.statistics
//   });

//   // Create scatter plot with raw values
//   const seriesData = hasData ? [
//     {
//       name: 'Actual Measurements',
//       type: 'scatter',
//       data: actualPoints.map(point => ({
//         x: point.rpm,  // Raw RPM on X-axis
//         y: point.powerKW,  // Raw Power on Y-axis
//         rpm: point.rpm,
//         powerKW: point.powerKW,
//         timestamp: point.timestamp,
//         slip: point.slip,
//         load: point.load
//       })),
//       color: '#3B82F6',
//       marker: {
//         radius: 6,
//         symbol: 'circle'
//       }
//     }
//   ] : [];

//   const options = {
//     chart: {
//       type: 'scatter',
//       height: 450
//     },
//     title: {
//       text: null
//     },
//     xAxis: {
//       title: {
//         text: 'Engine RPM',
//         style: {
//           color: '#64748B',
//           fontWeight: '600'
//         }
//       },
//       min: hasData ? Math.min(...actualPoints.map(p => p.rpm)) * 0.9 : 0,
//       max: hasData ? Math.max(...actualPoints.map(p => p.rpm)) * 1.1 : 100,
//       labels: {
//         style: {
//           color: '#64748B'
//         }
//       }
//     },
//     yAxis: {
//       title: {
//         text: 'Power Output (kW)',
//         style: {
//           color: '#64748B',
//           fontWeight: '600'
//         }
//       },
//       min: hasData ? Math.min(...actualPoints.map(p => p.powerKW)) * 0.9 : 0,
//       max: hasData ? Math.max(...actualPoints.map(p => p.powerKW)) * 1.1 : 100,
//       labels: {
//         style: {
//           color: '#64748B'
//         }
//       }
//     },
//     tooltip: {
//       useHTML: true,
//       formatter: function() {
//         const point = this.point;
//         return `
//           <div class="space-y-2">
//             <div class="font-semibold text-slate-800">Measurement Details</div>
//             <div class="space-y-1">
//               <div class="flex justify-between">
//                 <span class="text-slate-600">RPM:</span>
//                 <span class="font-semibold">${point.rpm}</span>
//               </div>
//               <div class="flex justify-between">
//                 <span class="text-slate-600">Power:</span>
//                 <span class="font-semibold">${point.powerKW} kW</span>
//               </div>
//               ${point.slip ? `
//                 <div class="flex justify-between">
//                   <span class="text-slate-600">Slip:</span>
//                   <span class="font-semibold">${point.slip}%</span>
//                 </div>
//               ` : ''}
//               ${point.load ? `
//                 <div class="flex justify-between">
//                   <span class="text-slate-600">Load:</span>
//                   <span class="font-semibold">${(point.load * 100).toFixed(1)}%</span>
//                 </div>
//               ` : ''}
//               <div class="pt-2 mt-2 border-t border-slate-200">
//                 <div class="text-xs text-slate-500">
//                   ${new Date(point.timestamp).toLocaleString()}
//                 </div>
//               </div>
//             </div>
//           </div>
//         `;
//       }
//     },
//     series: seriesData
//   };

//   return (
//     <div className="bg-white rounded-xl border border-slate-200 shadow-sm">
//       <div className="px-6 py-4 border-b border-slate-200">
//         <div className="flex items-center justify-between">
//           <div className="flex items-center gap-3">
//             <div className="p-2 bg-blue-50 text-blue-600 rounded-lg">
//               <Activity className="w-5 h-5" />
//             </div>
//             <div>
//               <h2 className="text-lg font-semibold text-slate-800">
//                 Engine {selectedEngine?.toUpperCase()} - Raw Performance Data
//               </h2>
//               <p className="text-sm text-slate-500">
//                 Actual measurements without MCR reference
//               </p>
//             </div>
//           </div>
          
//           {hasData && (
//             <div className="flex items-center gap-2">
//               <div className="flex items-center">
//                 <span className="w-2 h-2 rounded-full bg-blue-500 mr-2"></span>
//                 <span className="text-sm text-slate-600">
//                   {actualPoints.length} measurement{actualPoints.length !== 1 ? 's' : ''}
//                 </span>
//               </div>
//               <span className={`px-2 py-1 text-xs font-medium rounded ${
//                 enginePowerCurveData.dataQuality?.confidence === 'high' 
//                   ? 'bg-green-100 text-green-800'
//                   : enginePowerCurveData.dataQuality?.confidence === 'medium'
//                   ? 'bg-yellow-100 text-yellow-800'
//                   : 'bg-red-100 text-red-800'
//               }`}>
//                 {enginePowerCurveData.dataQuality?.confidence?.toUpperCase() || 'LOW'}
//               </span>
//             </div>
//           )}
//         </div>
        
//         {enginePowerCurveData.disclaimer && (
//           <div className="mt-3 p-2 bg-amber-50 border border-amber-200 rounded text-sm text-amber-800">
//             ⚠️ {enginePowerCurveData.disclaimer}
//           </div>
//         )}
//       </div>
      
//       <div className="p-6">
//         {hasData ? (
//           <>
//             {/* Statistics Cards */}
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
//               <div className="bg-slate-50 rounded-lg p-4 border border-slate-200">
//                 <div className="text-sm text-slate-500 font-medium mb-1">RPM Range</div>
//                 <div className="text-2xl font-semibold text-slate-800">
//                   {enginePowerCurveData.statistics?.rpm?.min || 0} - {enginePowerCurveData.statistics?.rpm?.max || 0}
//                 </div>
//                 <div className="text-xs text-slate-500 mt-1">
//                   Avg: {(enginePowerCurveData.statistics?.rpm?.avg || 0).toFixed(1)}
//                 </div>
//               </div>
              
//               <div className="bg-slate-50 rounded-lg p-4 border border-slate-200">
//                 <div className="text-sm text-slate-500 font-medium mb-1">Power Range</div>
//                 <div className="text-2xl font-semibold text-slate-800">
//                   {enginePowerCurveData.statistics?.power?.min || 0} - {enginePowerCurveData.statistics?.power?.max || 0} kW
//                 </div>
//                 <div className="text-xs text-slate-500 mt-1">
//                   Avg: {(enginePowerCurveData.statistics?.power?.avg || 0).toFixed(1)} kW
//                 </div>
//               </div>
              
//               <div className="bg-slate-50 rounded-lg p-4 border border-slate-200">
//                 <div className="text-sm text-slate-500 font-medium mb-1">Data Summary</div>
//                 <div className="text-2xl font-semibold text-slate-800">
//                   {actualPoints.length} point{actualPoints.length !== 1 ? 's' : ''}
//                 </div>
//                 <div className="text-xs text-slate-500 mt-1">
//                   Updated: {new Date(enginePowerCurveData.updatedAt).toLocaleDateString()}
//                 </div>
//               </div>
//             </div>
            
//             {/* Chart */}
//             <div className="mb-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h3 className="text-sm font-semibold text-slate-700">
//                   RPM vs Power Output
//                 </h3>
//                 <div className="flex items-center text-sm text-slate-500">
//                   <span className="w-2 h-2 rounded-full bg-blue-500 mr-2"></span>
//                   Each point represents one measurement
//                 </div>
//               </div>
//               <div className="border border-slate-200 rounded-lg p-4 bg-white">
//                 <HighchartsReact
//                   highcharts={Highcharts}
//                   options={options}
//                 />
//               </div>
//             </div>
            
//             {/* Data Table */}
//             <div>
//               <h3 className="text-sm font-semibold text-slate-700 mb-3">
//                 Measurement Details
//               </h3>
//               <div className="overflow-x-auto border border-slate-200 rounded-lg">
//                 <table className="min-w-full divide-y divide-slate-200">
//                   <thead className="bg-slate-50">
//                     <tr>
//                       <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
//                         Time
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
//                         RPM
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
//                         Power (kW)
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
//                         Slip
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">
//                         Load
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody className="divide-y divide-slate-200">
//                     {actualPoints.map((point, index) => (
//                       <tr key={index} className="hover:bg-slate-50">
//                         <td className="px-4 py-3 text-sm text-slate-600">
//                           {new Date(point.timestamp).toLocaleTimeString([], {
//                             hour: '2-digit',
//                             minute: '2-digit'
//                           })}
//                         </td>
//                         <td className="px-4 py-3">
//                           <div className="text-sm font-semibold text-slate-800">
//                             {point.rpm}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3">
//                           <div className="text-sm font-semibold text-blue-600">
//                             {point.powerKW} kW
//                           </div>
//                         </td>
//                         <td className="px-4 py-3">
//                           <div className="text-sm text-slate-600">
//                             {point.slip ? `${point.slip}%` : '-'}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3">
//                           <div className="text-sm text-slate-600">
//                             {point.load ? `${(point.load * 100).toFixed(1)}%` : '-'}
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </>
//         ) : (
//           <div className="text-center py-12">
//             <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-slate-100 text-slate-400 mb-4">
//               <Activity className="w-8 h-8" />
//             </div>
//             <h3 className="text-lg font-semibold text-slate-700 mb-2">
//               No Performance Data Available
//             </h3>
//             <p className="text-slate-500 max-w-md mx-auto">
//               No engine performance measurements have been recorded yet.
//               Data will appear here when measurements are taken.
//             </p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

export default EnginePerformanceChart2;